import { STATUSES, ACTIONS } from "./constants";
import { Actions, Timeout, TimerState } from "./types";

export const getInitialState = (timeout?: Timeout): TimerState => ({
  timeout,
  status: STATUSES.STOPPED,
  startedAt: Date.now(),
});

export const reducer = (state: TimerState, action: Actions): TimerState => {
  switch (action.type) {
    case ACTIONS.START:
      return {
        ...state,
        status: STATUSES.STARTED,
        startedAt: Date.now(),
      };

    case ACTIONS.PAUSE:
      return {
        ...state,
        status: STATUSES.PAUSED,
        timeout: action.payload,
      };

    case ACTIONS.STOP:
      return {
        ...state,
        status: STATUSES.STOPPED,
      };

    default:
      throw new Error(`Unsupported action type: ${action.type}`);
  }
};
